module.exports = __webpack_public_path__ + "img/metal_o@2x.2db7ee7d.png";